export const it = {
  notFoundPage: {
    notFoundMessage: "Pagina non trovata",
    error404: "Errore 404",
    backButtonText: "Vai su hype.it",
  },
};
